/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './grid.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/grid/grid.component';
const styles_GridComponent:any[] = [i0.styles];
export const RenderType_GridComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_GridComponent,data:{}});
function View_GridComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any)))],
      (null as any),(null as any));
}
function View_GridComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),[[8,'className',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_GridComponent_2)),i1.ɵdid(540672,
          (null as any),0,i2.NgTemplateOutlet,[i1.ViewContainerRef],{ngTemplateOutlet:[0,
              'ngTemplateOutlet']},(null as any))],(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,3,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_co.cols[_v.context.index]? ('col-md-' + _co.cols[_v.context.index]): '');
    _ck(_v,1,0,currVal_0);
  });
}
export function View_GridComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'div',[['class',
      'container-fluid']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'div',[['class',
      'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GridComponent_1)),
      i1.ɵdid(802816,(null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    var _co:i3.GridComponent = _v.component;
    const currVal_0:any = _co.templates;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_GridComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'admin-grid',([] as any[]),
      (null as any),(null as any),(null as any),View_GridComponent_0,RenderType_GridComponent)),
      i1.ɵdid(49152,(null as any),1,i3.GridComponent,([] as any[]),(null as any),(null as any)),
      i1.ɵqud(603979776,1,{templates:1})],(null as any),(null as any));
}
export const GridComponentNgFactory:i1.ComponentFactory<i3.GridComponent> = i1.ɵccf('admin-grid',
    i3.GridComponent,View_GridComponent_Host_0,{cols:'cols'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2dyaWQvZ3JpZC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvZ3JpZC9ncmlkLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2dyaWQvZ3JpZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2dyaWQvZ3JpZC5jb21wb25lbnQudHMuR3JpZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJjb250YWluZXItZmx1aWRcIj48ZGl2IGNsYXNzPVwicm93XCI+PG5nLWNvbnRhaW5lciAqbmdGb3I9XCJsZXQgdGVtcGxhdGUgb2YgdGVtcGxhdGVzOyBsZXQgaT1pbmRleFwiPjxkaXYgW2NsYXNzXT1cImNvbHNbaV0gPyAnY29sLW1kLScgKyBjb2xzW2ldIDogJydcIj48bmctY29udGFpbmVyICpuZ1RlbXBsYXRlT3V0bGV0PVwidGVtcGxhdGVcIj48L25nLWNvbnRhaW5lcj48L2Rpdj48L25nLWNvbnRhaW5lcj48L2Rpdj48L2Rpdj4iLCI8YWRtaW4tZ3JpZD48L2FkbWluLWdyaWQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OztvQkNBOEo7TUFBQTs7OztvQkFBaEg7TUFBQTtNQUE4RDtVQUFBLDhEQUFrRDtVQUFBLDBFQUFBO1VBQUE7Y0FBQTtJQUFjO0lBQWQsV0FBYyxTQUFkOzs7SUFBN0M7SUFBTCxXQUFLLFNBQUw7Ozs7b0JBQTVHO01BQUE7TUFBQSxnQkFBNkI7TUFBQTtNQUFpQjthQUFBOzRCQUFBOztJQUFjO0lBQWQsV0FBYyxTQUFkOzs7O29CQ0E5QztNQUFBO2FBQUE7YUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/grid/grid.component.ngfactory.ts